<header class="logo mat-dialog-container no-margin">
    <div class="container">
        <div class="logo-image">
            <img src="assets/images/logo-black.svg" alt="Boomcaster">
        </div>
        <button mat-button mat-dialog-close class="close" (click)="close()">
            <span class="material-icons">
                close
            </span>
            Close
        </button>
    </div>
</header>
<section class="join-session-section text-center">
    <div class="section-title">
        <h1>This session will be recorded in studio quality. Here are some best practices and recommendations for you:</h1>
        <!-- <p>This session will be recorded in studio quality. Here are some steps you can take to help us record at the highest quality possible:</p> -->
    </div>
    <div class="container">
        <div class="row">
            <div class="col m4 s12 img-list-info">
                <div class="img-area">
                    <img src="assets/images/cancel-ic-1.svg" />
                </div>
                <h2>Applications</h2>
                <p>Exit applications that are not needed during this session. CPU and memory demands can be high, even when running in the background</p>
            </div>
            <div class="col m4 s12 img-list-info">
                <div class="img-area">
                    <img src="assets/images/cancel-ic-2.svg" />
                </div>
                <h2>Browser Tabs</h2>
                <p>Close browser tabs that you no longer need. Every tab you have open, requires memory and CPU.</p>
            </div>
            <div class="col m4 s12 img-list-info">
                <div class="img-area">
                    <img src="assets/images/cancel-ic-3.svg" />
                </div>
                <h2>Laptop Charger</h2>
                <p>Plug in the charger, if you are using laptop to record. Laptops throttle CPU, when running on battery power.</p>
            </div>
        </div>
        <div class="btn-area text-center">
            <button mat-flat-button class="button button-large filled" (click)="joinSession()">Continue</button>
        </div>
    </div>

</section>